<template>
    <div class="list-info">
        <div class="flex-x title" style="padding-bottom:30px;">
            <img src="/img/bigdata/title-icon.png" style="">
            <span style="margin-left:10px;">溢价成交资产</span>
        </div>
        <div class="search">
            <span>资产名称：</span>
            <input type="text" v-model="name">
            <button @click="check">查询</button>
        </div>
        <div class="items flex-x">
            <div class="item flex-y" v-for="(item,index) in list" :key="index" @click="openDetail(item.href)">
                <img :src="item.imageUrl" style="width:254px;height:150px;">
                <div>
                    <div class="name" style="font-size:16px;">{{item.assetName}}</div>
                    <div class="price">成交价：{{item.currentPrice}} 元/年</div>
                    <div class="unit-price flex-x">
                        <span>{{item.startPriceDay}} 元/平方米/日</span>
                        <span>
                            溢价
                            <i>{{item.premiumRate}}% &uarr;</i>
                        </span>
                    </div>
                </div>
            </div>
            <div class="pages" v-if="list.length>0">
                <!-- <a-pagination v-model="page" :total="total" @change="pageChange" /> -->
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :page-size='20'
                    :current-page='page'
                    @current-change='pageChange'
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <div class="angle angle-1"></div>
        <div class="angle angle-2"></div>
        <div class="angle angle-3"></div>
        <div class="angle angle-4"></div>
    </div>
</template>
<script>
import {premiumList} from '@/api/premium.js'
export default {
    name:'listInfo',
    data(){
        return{
            name:'',
            list:[],
            total:0,
            page:1,
            perPage:15,
            companyId:'',
        }
    },
    methods:{
        check(){
            this.page = 1;
            this.getList();
        },
        pageChange(val){
            this.page = val;
            this.getList();
        },
        getList(){
            premiumList({companyId:this.companyId,name:this.name,page:this.page,perPage:this.perPage}).then(res=>{
                let data = res.data;
                if(data.code ==='000'){
                    this.list = data.content.list||[];
                    this.total = data.content.total;
                }else{
                    console.log(data.desc)
                }
            })
        },
        openDetail(href){
            window.open(href,'_blank')
        }
    },
    created(){
        this.companyId = this.$route.query.companyId;
        this.getList()
    }
}
</script>
<style lang="scss">
.list-info{
    flex:1;
    padding:25px;
    border-radius:4px;
    border:1px solid rgba(29,62,143,1);
    color:#B8D7FF;
    font-size:16px;
    margin-bottom: 15px;
    position:relative;
    .title{
        justify-content: flex-start;
    }
    .search{
        font-size:14px;
        color:#fff;
        input{
            width:378px;
            height:38px;
            background-color: transparent;
            box-shadow:0px 0px 7px 0px rgba(29,62,143,1);
            border-radius:4px;
            border:1px solid rgba(29,62,143,1);
            padding:15px;
        }
        button{
            width:68px;
            height:38px;
            background:rgba(10,86,197,1);
            border-radius:4px;
            margin-left: 10px;
        }
    }
    .items{
        width:100%;
        margin-top:20px;
        flex-wrap: wrap;
        justify-content: flex-start;
        .item{
            width:280px;
            height:270px;
            cursor: pointer;
            margin-bottom: 15px;
            margin-right: 15px;
            padding:10px;
            justify-content: space-around;
            box-shadow:0px 4px 14px 0px rgba(0,0,0,0.08);
            border-radius:3px;
            border:1px solid rgba(29,62,143,1);
            font-size:12px;
            .price{
                align-self:flex-start;
                margin:8px 0;
            }
            .unit-price.flex-x{
                width:100%;
                justify-content: space-between;
            }
            .name{
                display: inline-block;
                width:224px;
                white-space: nowrap;
                overflow:hidden;
                text-overflow: ellipsis;
            }
        }
    }
    .pages{
        width:100%;
        text-align: right;
        .ant-pagination-prev .ant-pagination-item-link, .ant-pagination-next .ant-pagination-item-link{
            background-color:transparent!important;

        }
        .ant-pagination-item{
            background-color:transparent!important;

        }
        .anticon{
            color:#1890ff;
        }
        .ant-pagination-item a{
            color:#1890ff;
        }
        .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis, .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis{
            color:#1890ff;
        }
    }
}
</style>


